// Cobrar con el datáfono de recepción y el QR de pago.
export const datafono = {
  card: {
    name: "Terminal de paiement",
    description: "Encaissez avec le terminal de la réception depuis la réservation",
    count: "{count} terminal | {count} terminaux",
  },
  settings: {
    title: "Terminaux de paiement de la réception",
    lead: "Encaissez avec le terminal depuis la réservation : le montant s'affiche sur l'appareil, le client passe sa carte et la réservation est marquée payée automatiquement.",
    listTitle: "Vos terminaux",
    add: "Ajouter un terminal",
    loading: "Chargement…",
    empty: "Vous n'avez encore aucun terminal connecté.",
    simulatorTag: "Simulateur",
    online: "En ligne",
    offlineSince: "Hors ligne · dernier signal {when}",
    neverConnected: "Pas encore connecté",
    bridgeVersion: "pont {version}",
    token: "jeton",
    newToken: "Nouveau jeton",
    remove: "Retirer",
    howTitle: "Comment le connecter",
    how1: "Ajoutez le terminal ici et copiez son jeton (il n'est affiché qu'une fois).",
    how2: "Sur l'ordinateur de la réception où le terminal est branché, lancez le pont WACheckin avec ce jeton.",
    how3: "Quand il indique « En ligne », vous pouvez encaisser depuis n'importe quelle réservation : Ajouter un paiement → Carte / terminal.",
    bankNote: "Avec Redsys, il faut souscrire auprès de votre banque le « TPV-PC » (mode Implantado) et un terminal certifié. Un terminal autonome en WiFi ou 4G ne peut pas être connecté.",
    addTitle: "Ajouter un terminal",
    nameLabel: "Nom",
    namePlaceholder: "Par exemple : Réception",
    typeLabel: "Type",
    typeReal: "Terminal Redsys (TPV-PC)",
    typeRealHint: "Le terminal de votre banque, branché à l'ordinateur de la réception.",
    typeSim: "Simulateur",
    typeSimHint: "Pour tester sans appareil. Aucun argent n'est débité.",
    cancel: "Annuler",
    saving: "Enregistrement…",
    create: "Ajouter",
    saveError: "Impossible d'enregistrer. Réessayez.",
    loadError: "Impossible de charger les terminaux.",
    tokenTitle: "Jeton du terminal",
    tokenLead: "Saisissez ces deux données dans le pont de l'ordinateur de la réception.",
    apiLabel: "Serveur",
    tokenLabel: "Jeton",
    copy: "Copier",
    copied: "Copié",
    tokenOnce: "Enregistrez-le maintenant : il ne sera plus affiché. S'il est perdu, générez-en un nouveau et l'ancien ne sera plus valable.",
    done: "Terminé",
    newTokenConfirm: "Générer un nouveau jeton pour « {name} » ? L'actuel ne sera plus valable et il faudra le saisir à nouveau dans le pont.",
    removeConfirm: "Retirer le terminal « {name} » ? On ne pourra plus lui envoyer d'encaissements.",
    removed: "Terminal retiré.",
  },
  add: {
    sendTitle: "Encaisser sur le terminal",
    sendHint: "Le montant s'affiche sur l'appareil et la réservation est marquée payée automatiquement au passage de la carte.",
    online: "en ligne",
    offline: "hors ligne",
    noneOnline: "Aucun terminal n'est en ligne. Vérifiez que l'ordinateur de la réception est allumé et le pont ouvert.",
    manualTitle: "Déjà encaissé, juste l'enregistrer",
    manualHint: "Il est enregistré comme payé sans passer par le terminal.",
    submit: "Encaisser sur le terminal",
  },
  line: {
    pendiente: "Envoi au terminal",
    enviado: "Sur le terminal",
    sin_respuesta: "Sans réponse · vérifier",
  },
  cobro: {
    terminal: "Terminal",
    cancel: "Annuler l'encaissement",
    hide: "Continuer en arrière-plan",
    notCharged: "Non encaissé",
    wasCharged: "Oui, encaissé",
    retry: "Réessayer",
    close: "Fermer",
    authCode: "Autorisation {code}",
    genericError: "Impossible de terminer. Réessayez.",
    title: {
      pendiente: "Envoi au terminal…",
      enviado: "Demandez la carte",
      cobrado: "Encaissé",
      rechazado: "Carte refusée",
      cancelado: "Encaissement annulé",
      error: "Le terminal a renvoyé une erreur",
      caducado: "Le terminal n'a pas répondu",
      sin_respuesta: "A-t-il été encaissé ?",
    },
    text: {
      pendiente: "Le montant apparaîtra sur le terminal dans quelques secondes.",
      enviado: "Le montant est sur le terminal. Dès qu'il est payé, la réservation est marquée automatiquement.",
      cobrado: "Ce paiement est enregistré sur la réservation.",
      rechazado: "Rien n'a été encaissé.",
      cancelado: "Rien n'a été encaissé.",
      error: "Rien n'a été encaissé.",
      caducado: "Rien n'a été encaissé.",
      sin_respuesta: "Le terminal n'a pas renvoyé le résultat. Vérifiez sur l'appareil ou le ticket avant d'encaisser à nouveau.",
    },
  },
  qr: {
    button: "Afficher le QR",
    title: "Scannez pour payer",
    text: "Le client le scanne avec son téléphone et paie sur la page sécurisée de la passerelle. La réservation est marquée payée automatiquement.",
    copy: "Copier le lien",
    copied: "Lien copié",
    close: "Fermer",
  },
};
